<template>
  <div>
    <div class="chat-history" ref="history">
      <div
        v-for="(conversation, index) in conversations"
        :key="index"
        @mouseover="hoverId = conversation._id"
        @mouseleave="hoverId = ''"
      >
        <div v-if="isShowDate(index)" class="date">
          <div class="line"></div>
          <div class="value">{{ formatDate(conversation.created_at) }}</div>
        </div>
        <div
          v-if="
            conversation.message &&
              conversation.message.message_type === 'action'
          "
          class="action"
        >
          <div class="line"></div>
          <div class="value">
            <p>{{ actionText(conversation) }}</p>
          </div>
        </div>
        <div
          v-if="
            conversation.message && conversation.message.message_type === 'amd'
          "
          class="action"
        >
          <div class="line"></div>
          <div class="value">
            <p>{{ amdText(conversation) }}</p>
          </div>
        </div>

        <div
          v-if="
            !(
              conversation.message &&
              conversation.message.message_type === 'amd'
            )
          "
          :class="
            botQc.isTuning &&
            conversation.sender === 'customer' &&
            conversation.message &&
            !conversation.message.utterance.includes('NO-INPUT')
              ? 'box-tuning'
              : ''
          "
        >
          <div
            v-if="
              !(
                conversation.message &&
                conversation.message.message_type === 'amd'
              )
            "
            :conversation_id="conversation.conversation_id"
            :class="
              conversation.sender == 'customer'
                ? 'chat-message font-size-body'
                : 'chat-message chat-message-right font-size-body'
            "
          >
            <div>
              <div v-if="conversation.sender === 'customer'" class="avatar">
                <img :src="customer.profile.picture || avatar" alt="" />
              </div>

              <div v-else-if="conversation.sender === 'bot'" class="avatar">
                <img :src="require('@/assets/chatbotix.png')" alt="" />
              </div>

              <div v-else class="avatar">
                <img
                  :src="
                    avatarAgent[conversation.agent_id]
                      ? avatarAgent[conversation.agent_id]
                      : avatar
                  "
                  alt=""
                />
              </div>

              <div v-if="channel === 'chat'">
                <div v-if="typeof conversation.message === 'undefined'">
                  <payload-unsupport
                    :sessionId="sessionId"
                    :conversation="conversation"
                    @debugPopup="debugPopup"
                  />
                </div>
                <div v-else-if="conversation.message.message_type === 'text'">
                  <payload-text
                    :sessionId="sessionId"
                    :conversation="conversation"
                    @debugPopup="debugPopup"
                    @learnPopup="learnPopup"
                  />
                </div>
                <div
                  v-else-if="conversation.message.message_type === 'buttons'"
                >
                  <payload-button
                    :conversation="conversation"
                    @debugPopup="debugPopup"
                  />
                </div>
                <div v-else-if="conversation.message.message_type === 'media'">
                  <payload-media
                    :sessionId="sessionId"
                    :conversation="conversation"
                    @onResendFile="resendFile"
                    @onCancelDeliverFile="cancelDeliverFile"
                    @debugPopup="debugPopup"
                  />
                </div>
                <div
                  v-else-if="
                    conversation.message.message_type === 'quick_replies'
                  "
                >
                  <payload-quick-reply
                    :conversation="conversation"
                    @debugPopup="debugPopup"
                  />
                </div>
                <div
                  v-else-if="conversation.message.message_type === 'generic'"
                >
                  <payload-generic
                    :conversation="conversation"
                    @debugPopup="debugPopup"
                  />
                </div>
                <div
                  v-else-if="conversation.message.message_type === 'postback'"
                >
                  <payload-postback
                    :sessionId="sessionId"
                    :conversation="conversation"
                    @debugPopup="debugPopup"
                    @learnPopup="learnPopup"
                  />
                </div>
                <div v-else>
                  <payload-unknown
                    :conversation="conversation"
                    @debugPopup="debugPopup"
                  />
                </div>
              </div>
              <div v-else-if="channel === 'voice'">
                <payload-voice
                  :sessionId="sessionId"
                  :conversation="conversation"
                  @learnPopup="learnPopup"
                  @debugPopup="debugPopup"
                />
              </div>

              <div
                v-if="isMessageDelivered(conversation.message)"
                :class="`time font-size-x-small ${channel}`"
              >
                <div v-if="conversation.sender === 'customer'">
                  <div v-visible="hoverId === conversation._id">
                    <v-icon
                      v-if="audio.canPlay[index] && channel === 'voice'"
                      v-on:click="audioClick(index)"
                    >
                      {{
                        audio.isPlay[index]
                          ? 'far fa-stop-circle'
                          : 'far fa-play-circle'
                      }}
                    </v-icon>
                    <v-tooltip
                      top
                      v-if="channel === 'voice' && !audio.canPlay[index]"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          v-bind="attrs"
                          v-on="on"
                          class="custom-disabled"
                        >
                          far fa-play-circle
                        </v-icon>
                      </template>
                      <span>File not found</span>
                    </v-tooltip>

                    <v-icon
                      v-if="audio.canPlay[index] && channel === 'voice'"
                      v-on:click="downloadClick(index)"
                    >
                      far fa-arrow-alt-circle-down
                    </v-icon>
                    <v-tooltip
                      top
                      v-if="channel === 'voice' && !audio.canPlay[index]"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          v-bind="attrs"
                          v-on="on"
                          class="custom-disabled"
                        >
                          far fa-arrow-alt-circle-down
                        </v-icon>
                      </template>
                      <span>File not found</span>
                    </v-tooltip>

                    <v-icon @click="copyClick($event, channel, index)">
                      far fa-copy
                    </v-icon>
                  </div>
                </div>
                <div v-else>
                  <div v-visible="hoverId === conversation._id">
                    <v-icon
                      @click="copyClick($event, channel, index)"
                      class="m-l-25"
                    >
                      far fa-copy
                    </v-icon>
                  </div>
                </div>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <span
                      :class="
                        conversation.sender === 'customer'
                          ? ''
                          : 'icon-message-right'
                      "
                      v-bind="attrs"
                      v-on="on"
                    >
                      {{ conversation.created_at | timeFormat }}
                    </span>
                  </template>
                  <span>
                    {{ conversation.created_at | datetimeFormatWithSeconds }}
                  </span>
                </v-tooltip>
              </div>

              <div
                v-if="isMessageFailed(conversation.message)"
                class="send-failed"
              >
                <v-tooltip top>
                  <template #activator="{ on }">
                    <v-icon color="red" v-on="on">mdi-alert-circle</v-icon>
                  </template>
                  <span>Failed</span>
                </v-tooltip>
              </div>
            </div>
          </div>
          <bot-qc
            v-if="botQc.isTuning"
            :channel="channel"
            :conversation="conversation"
            :intents="intents"
            :index="index"
          />
        </div>
      </div>
      <!-- // use in  system-message -->
      <div v-if="systemMsg.length > 0" class="scroll-container">
        <div
          class="system-message font-size-sub"
          v-for="(msg, index) in systemMsg"
          :key="index"
        >
          <!-- ถ้า มี transfer note ทำ if -->
          <span v-if="msg.transfer_from === 'agent'">
            {{ msg.created_at | timeFormat }} <b>{{ msg.destination }}</b>
            {{ msg.status }} <b>{{ msg.queues }}</b> <br />
            <div class="wrap-word">{{ msg.transfer_note }}</div>
          </span>
          <!-- ถ้า Staus = Picked up by -->
          <span v-else-if="msg.status === 'Picked up by'">
            {{ msg.created_at | timeFormat }} {{ msg.status }}
            <b>{{ msg.destination }}</b>
          </span>
          <!-- ถ้า transfer แต่ไม่มี  transfer note-->
          <span v-else-if="msg.transfer_from === 'bot'">
            {{ msg.created_at | timeFormat }} {{ msg.status }}
            <b>{{ msg.queues }}</b>
          </span>
          <!-- ถ้า Staus = Picked up by -->
          <span v-else-if="msg.status === 'hanged up'">
            {{ msg.created_at | timeFormat }} <b>{{ msg.destination }}</b>
            {{ msg.status }}
          </span>

          <!-- <span v-html="name"> </span> -->
        </div>
      </div>
      <!-- // use in  system-message -->
      <!-- <div v-if="action === 'on call'" class="text-center">
        <div class="d-inline-flex cursor-pointer">
          <v-icon>fas fa-sync</v-icon>
          <div id="data-refresh" class="m-l-5" @click="dataRefresh">
            Refresh
          </div>
        </div>
      </div> -->

      <div v-if="isEndSession" class="date">
        <div class="line"></div>
        <div class="value end-session">End of conversation</div>
      </div>

      <div v-if="botQc.isTuning" class="d-flex justify-space-between m-t-15">
        <div class="d-flex v-middle">
          <v-menu v-if="botQc.qcBy.length > 0" :absolute="true">
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                id="icon-dots"
                class="p-l-10 p-r-10"
                v-bind="attrs"
                v-on="on"
                small
              >
                fa-ellipsis-v
              </v-icon>
            </template>
            <v-list dense>
              <v-list-item
                v-for="(option, index) in options"
                :key="index"
                @click="optionClick(option.action)"
              >
                <v-list-item-content>
                  <v-list-item-subtitle
                    :id="`list${index}`"
                    class="font-size-body"
                    >{{ option.title }}</v-list-item-subtitle
                  >
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-menu>

          <v-tooltip top :open-delay="700">
            <template v-slot:activator="{ on, attrs }">
              <div
                v-if="botQc.qcBy.length > 0"
                v-bind="attrs"
                v-on="on"
                class="text-small"
              >
                QC by <b>{{ botQc.qcBy.length }}</b> persons
              </div>
              <div v-else class="text-small">
                QC by <b>{{ botQc.qcBy.length }}</b> persons
              </div>
            </template>
            <span v-html="showQcBy(botQc.qcBy)"></span>
          </v-tooltip>
        </div>
        <div>
          <v-btn class="btn-secondary" small @click="cancelBotQc">Cancel</v-btn>
          <v-btn class="btn-primary m-l-10" small @click="saveBotQc">
            Save
          </v-btn>
        </div>
      </div>
    </div>

    <!-- video dialog -->
    <v-dialog
      v-model="dialogVideo"
      @keydown.esc="dialogVideo = false"
      content-class="medium"
      @input="v => v || dialogVideoClosed()"
    >
      <v-card class="mb-n2">
        <video ref="chatVideo" width="600" controls :src="dialogVideoUrl">
          Your browser does not support HTML video.
        </video>
      </v-card>
    </v-dialog>

    <!-- image dialog -->
    <v-overlay
      z-index="100"
      :value="dialogImage"
      @click.native="closeDialogImage"
    >
      <img
        :src="dialogImageUrl"
        class="overlay-image"
        :style="{
          'max-width': maxWidthImageDialog,
          'max-height': maxHeightImageDialog
        }"
      />
    </v-overlay>

    <dialog-learn
      v-if="dialogLearn"
      :dialogLearn="dialogLearn"
      :word="word"
      :intents="intents"
      :testNlu="testNlu"
      :logNluResult="logNluResult"
      @closeLearn="closeLearn"
      @saveLearn="saveLearn"
    />

    <dialog-debug
      v-if="dialogDebug"
      :dialogDebug="dialogDebug"
      :logBotCaller="logBotCaller"
      :logBotCallerIndex="logBotCallerIndex"
      @closeDebug="closeDebug"
    />

    <dialog-confirm
      v-if="dialogConfirm.open"
      :dialogConfirm="dialogConfirm"
      @dialogConfirmClick="dialogConfirmClick"
    />

    <snackbar v-if="snackbar.open" :snackbar="snackbar" />
  </div>
</template>

<script>
import Moment from 'moment'
import Avatar from '@/assets/guest-user.png'

import apiUser from '@/apis/user'
// import apiTraining from '@/apis/training_phrase'
import apiIntent from '@/apis/intent'

import apiDebug from '@/apis/debug'

import PayloadText from './payloads/text'
import PayloadButton from './payloads/button'
import PayloadMedia from './payloads/media'
import PayloadQuickReply from './payloads/quick_reply'
import PayloadGeneric from './payloads/generic'
import PayloadPostback from './payloads/postback'
import PayloadUnknown from './payloads/unknown'
import PayloadUnsupport from './payloads/unsupport'
import PayloadVoice from './payloads/voice'
import Const from '@/utils/const'

import DialogLearn from './components/dialog_learn'
import DialogDebug from './components/dialog_debug'
import DialogConfirm from './components/dialog_confirm'
import BotQc from './components/bot_qc'
import Snackbar from '@/components/snackbar'

export default {
  name: 'Conversation',
  components: {
    PayloadText,
    PayloadButton,
    PayloadMedia,
    PayloadQuickReply,
    PayloadGeneric,
    PayloadPostback,
    PayloadUnknown,
    PayloadUnsupport,
    PayloadVoice,
    DialogLearn,
    DialogDebug,
    DialogConfirm,
    BotQc,
    Snackbar
  },
  props: {
    conversations: Array,
    action: String,
    isEndSession: Boolean,
    channel: String,
    customer: {
      type: Object,
      default: () => {
        return {
          profile: {}
        }
      }
    },
    sessionId: String,
    botQc: {
      type: Object,
      default: () => {
        return {
          isTuning: false,
          qcBy: []
        }
      }
    },
    systemMsg: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data() {
    return {
      avatar: Avatar,
      avatarAgent: [],
      audio: {
        files: [],
        path: [],
        isPlay: [],
        canPlay: [],
        indexConver: ''
      },
      audioDefault: {
        files: [],
        path: [],
        isPlay: [],
        canPlay: [],
        indexConver: ''
      },
      window: {
        width: 0,
        height: 0
      },
      dialogVideo: false,
      dialogVideoUrl: '',
      dialogImage: false,
      dialogImageUrl: '',
      hoverId: '',
      dialogLearn: false,
      dialogDebug: false,
      word: '',
      intents: [],
      testNlu: {},
      snackbar: {
        open: false,
        colorSnackbar: '',
        textSnackbar: ''
      },
      logBotCaller: [],
      logBotCallerIndex: -1,
      logNluResult: {},
      hasChangeBotQc: false,
      options: [{ title: 'Clear QC result', action: 'clear' }],
      dialogConfirm: {
        open: false,
        text: '',
        textBtn: ''
      }
    }
  },
  created() {
    window.addEventListener('resize', this.handleResize)
    this.handleResize()
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize)
  },
  computed: {
    maxWidthImageDialog() {
      return `${this.window.width - 250}px`
    },
    maxHeightImageDialog() {
      return `${this.window.height - 250}px`
    }
  },
  directives: {
    visible: {
      update(el, binding) {
        el.style.visibility = binding.value ? 'visible' : 'hidden'
        // el.style.fontSize = '1.1rem'
      }
    }
  },

  watch: {
    conversations: {
      immediate: true,
      handler(newValue) {
        if (this.conversations && this.conversations.length !== 0) {
          this.newConversations()
        }
      }
    },
    'botQc.isTuning': {
      immediate: true,
      handler(newValue) {
        if (newValue) {
          apiIntent.getIntent().then(response => {
            this.intents = [...response.data]
          })
        }
      }
    }
  },
  methods: {
    isShowDate(currentIndex) {
      if (currentIndex === 0) {
        return true
      } else {
        const previousDate = this.formatDate(
          this.conversations[currentIndex - 1].created_at
        )
        const currentDate = this.formatDate(
          this.conversations[currentIndex].created_at
        )
        return previousDate !== currentDate
      }
    },
    cancelDeliverFile({ deliverId, sessionId }) {
      this.$emit('onCancelDeliverFile', { deliverId, sessionId })
    },
    resendFile({ deliverId, sessionId }) {
      this.$emit('onResendFile', { deliverId, sessionId })
    },
    isMessageDelivered(message) {
      let delivered = true
      if (message) {
        if (
          message.deliver &&
          message.deliver.status != Const.MessageDeliverStatus.SUCCEED
        ) {
          delivered = false
        }
      }
      return delivered
    },
    isMessageFailed(message) {
      if (message) {
        if (message.deliver) {
          return message.deliver.status == Const.MessageDeliverStatus.FAILED
        } else {
          return false
        }
      } else {
        return false
      }
    },
    getConversationPositionTop(conversationId) {
      let value = null
      const target = document.querySelectorAll(
        `[conversation_id='${conversationId}']`
      )
      if (target && target.length > 0) {
        value = target[0].getBoundingClientRect().top
      }
      return value
    },
    formatDate(date) {
      return Moment(date).format('DD MMM YYYY')
    },
    async newConversations() {
      if (this.audio.indexConver !== '') {
        for (
          let i = 0;
          i < this.audio.files[this.audio.indexConver].length;
          i++
        ) {
          this.audio.files[this.audio.indexConver][i].pause()
          this.audio.files[this.audio.indexConver][i].currentTime = 0
        }
      }
      this.audio = Object.assign({}, this.audioDefault)

      const conversations = this.conversations
      for (let i = 0; i < conversations.length; i++) {
        const agent_id = conversations[i].agent_id
        if (agent_id) {
          await this.getAvatarAgent(agent_id)
        }

        if (this.channel === 'voice') {
          const files =
            conversations[i].message.audios.length !== 0
              ? conversations[i].message.audios
              : ''
          this.audio.files[i] = []
          this.audio.path[i] = []
          for (let j = 0; j < files.length; j++) {
            this.audio.files[i][j] = new Audio(files[j])
            this.audio.path[i][j] = files[j]
          }
          this.audio.isPlay[i] = false
          this.audio.canPlay[i] = false
          this.audioOnCanPlay(i)
        }
      }
    },
    async audioOnCanPlay(index) {
      if (this.audio.files[index][0]) {
        this.audio.files[index][0].oncanplay = () => {
          const audio = this.audio
          audio.canPlay[index] = true
          this.audio = Object.assign({}, audio)
        }
      }
    },
    async downloadClick(index) {
      for (let i = 0; i < this.audio.files[index].length; i++) {
        // window.open(this.audio.path[index][i], '_blank')

        const element = document.createElement('a')
        element.setAttribute('href', this.audio.path[index][i])

        element.style.display = 'none'
        document.body.appendChild(element)

        element.click()
        document.body.removeChild(element)
      }
    },
    copyClick(event, channel, index) {
      // @click.shift.left.exact="copyPath(channel, index)"
      // @click.alt.left.exact="copyId(channel, index)"
      // @click.command.left.exact="copyId(channel, index)"

      if (event.shiftKey) this.copyPath(channel, index)
      else if (event.altKey || event.metaKey) this.copyId(channel, index)
      else this.copyText(channel, index)
    },
    copyText(channel, index) {
      const text = this.findMessage(channel, this.conversations[index]) // this.audio.path[index][0]
      if (text) {
        this.$copyText(text).then(() => {
          this.snackbar.colorSnackbar = 'success'
          this.snackbar.textSnackbar = 'Copied to clipboard'
          this.snackbar.open = true
        })
      }
    },
    copyPath(channel, index) {
      if (channel === 'voice') {
        const text = this.audio.path[index][0]
        if (text) {
          this.$copyText(text).then(() => {
            this.snackbar.colorSnackbar = 'success'
            this.snackbar.textSnackbar = 'Filename copied to clipboard'
            this.snackbar.open = true
          })
        }
      }
    },
    copyId(channel, index) {
      const text = this.conversations[index].conversation_id
      if (text) {
        this.$copyText(text).then(() => {
          this.snackbar.colorSnackbar = 'success'
          this.snackbar.textSnackbar = 'Conversation ID copied to clipboard'
          this.snackbar.open = true
        })
      }
    },
    audioClick(index) {
      if (this.audio.indexConver !== '') {
        for (
          let i = 0;
          i < this.audio.files[this.audio.indexConver].length;
          i++
        ) {
          this.audio.files[this.audio.indexConver][i].pause()
          this.audio.files[this.audio.indexConver][i].currentTime = 0
        }
        if (this.audio.indexConver !== index) {
          const audio = this.audio
          audio.isPlay[this.audio.indexConver] = false
          this.audio = Object.assign({}, audio)
        }
      }
      if (this.audio.isPlay[index]) {
        for (let i = 0; i < this.audio.files[index].length; i++) {
          this.audio.files[index][i].pause()
          this.audio.files[index][i].currentTime = 0
        }
        const audio = this.audio
        audio.isPlay[index] = false
        this.audio = Object.assign({}, audio)
      } else {
        this.audio.indexConver = index
        this.audio.files[index][0].play()
        const audio = this.audio
        audio.isPlay[index] = true
        this.audio = Object.assign({}, audio)
        const total = this.audio.files[index].length
        if (total > 1) {
          this.playNextAudio(this.audio.files[index][0], index, 0, total)
        } else {
          this.audio.files[index][0].onended = () => {
            const audio = this.audio
            audio.isPlay[index] = false
            this.audio = Object.assign({}, audio)
          }
        }
      }
    },
    playNextAudio(audio, indexConver, indexFile, total) {
      audio.addEventListener('ended', event => {
        // this.audioPlay.index = this.audioPlay.index + 1
        if (indexFile + 1 < total) {
          this.audio.files[indexConver][indexFile + 1].play()
          this.playNextAudio(
            this.audio.files[indexConver][indexFile + 1],
            indexConver,
            indexFile + 1,
            total
          )
        } else {
          const audio = this.audio
          audio.isPlay[indexConver] = false
          this.audio = Object.assign({}, audio)
        }
      })
    },
    handleResize() {
      this.window.width = window.innerWidth
      this.window.height = window.innerHeight
    },
    async getAvatarAgent(agent_id) {
      if (!this.avatarAgent[agent_id]) {
        const getAvatar = await apiUser.getAvatar(agent_id)

        const obj = this.avatarAgent
        obj[agent_id] = getAvatar.data.avatar
        this.avatarAgent = Object.assign({}, obj)
      }
    },
    showImage(url) {
      this.dialogImage = true
      this.dialogImageUrl = url
    },
    closeDialogImage() {
      this.dialogImage = false
      this.dialogImageUrl = ''
    },
    playVideo(url) {
      this.dialogVideo = true
      this.dialogVideoUrl = url
    },
    dialogVideoClosed() {
      this.$refs.chatVideo.pause()
      this.dialogVideoUrl = ''
    },
    actionText(conversation) {
      if (conversation.skill) {
        return `Transfer : skill ${conversation.skill}`
      } else if (conversation.destination_name) {
        return `Transfer : Destination ${conversation.destination_name}`
      }
      return
    },
    amdText(conversation) {
      if (conversation.message && conversation.message.utterance) {
        return conversation.message.utterance
      }
      return 'AMD'
    },
    // dataRefresh() {
    //   this.$emit('dataRefresh1', null)
    // },
    async learnPopup(obj) {
      this.dialogLearn = true
      this.word = obj.word

      const getIntent = await apiIntent.getIntent()
      const { data } = getIntent
      this.intents = [...data]

      //get nlu test result
      const getData = await apiDebug.getBotCaller(obj.query)
      if (
        getData.data &&
        getData.data.payload &&
        getData.data.payload.nlu_result
      ) {
        const result = getData.data.payload.nlu_result

        const newData = {}
        newData.intent = '-'
        newData.confidence = ''
        for (const property in result) {
          newData[property] = result[property]
        }

        this.logNluResult = newData
      } else this.logNluResult = {}
    },
    closeLearn() {
      this.dialogLearn = false
    },
    async saveLearn(data) {
      // Temporary disable and will remove in future for kpat-ai
      this.closeLearn()
      // try {
      //   const getIntent = await apiTraining.createTrainingPhrases(data)

      //   this.snackbar.colorSnackbar = 'success'
      //   this.snackbar.textSnackbar = 'Phrase added'
      //   this.snackbar.open = true
      // } catch {
      //   this.snackbar.colorSnackbar = 'error'
      //   this.snackbar.textSnackbar = 'Failed'
      //   this.snackbar.open = true
      // } finally {
      //   this.closeLearn()
      // }
    },
    async debugPopup(conversation) {
      this.dialogDebug = true

      // const getData = await apiDebug.getBotCaller(query)
      // this.logBotCaller = getData.data

      this.logBotCaller = conversation.bot_item || []
      this.logBotCallerIndex = conversation.index
    },
    closeDebug() {
      this.dialogDebug = false
    },
    findMessage(channel, conv) {
      if (channel === 'voice') {
        return conv.message.utterance
      } else {
        switch (conv.message.message_type) {
          case 'text':
          case 'buttons':
            return conv.message.payload.message

          case 'media':
            return conv.message.payload.url

          case 'quick_replies':
          case 'generic':
          case 'postback':
          default:
            return conv.message.payload
        }
      }
    },
    optionClick(action) {
      switch (action) {
        case 'clear':
          this.dialogConfirm = {
            open: true,
            text: 'Clear QC result?',
            textBtn: 'Clear QC'
          }
          break

        default:
          break
      }
    },
    dialogConfirmClick() {
      this.$emit('clearBotQc', this.sessionId)

      this.dialogConfirm = {
        open: false,
        text: '',
        textBtn: ''
      }
    },
    showQcBy(arr) {
      const text = []
      for (const obj of arr) {
        text.push(
          `${obj.email} - ${this.$options.filters.datetimeFormat(
            obj.updated_at
          )}`
        )
      }
      return text.join('<br>')
    },
    async cancelBotQc() {
      this.$emit('cancelBotQc', null)
    },
    async saveBotQc() {
      this.$emit('saveBotQc', {
        session_id: this.sessionId,
        conversations: this.conversations
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.card {
  max-height: 100%;
  min-height: 100%;
}
.display-flex {
  display: flex;
}
.reason {
  text-align: right;
}
.line-clamp {
  max-width: 200px;
  float: right;
}
.wrap-up {
  margin-top: 5px;
  border: 1px solid $table-header;
  border-radius: 10px;
  padding: 10px;
  height: 100px;
  overflow-y: auto;
}

.col {
  padding: 0px;
}
.border {
  background-color: $table-header;
  padding: 5px;
}
.f-s-0_7em {
  font-size: 0.7em;
}
.read-more {
  font-size: 0.9em;
  color: $primary;

  &:hover {
    cursor: pointer;
  }
}

.borderTop0 {
  overflow-y: auto;
  background-color: white;
  // height: calc(100% - 200px);
  max-height: calc(100vh - 165px);
  min-height: calc(100vh - 165px);
  // height: 44vmax;
  border: 1px solid;
  border-color: #ebebeb;
  border-top: 0px;
  // padding: 15px;
}
.agent {
  background-color: $primary;
  color: white;
  margin-right: 35px;
}
.transfer-dialog .dialog-title {
  padding: 6px 20px 6px 20px;
}
.transfer-dialog .dialog-body {
  height: 250px;
}
.endchat-dialog .dialog-body {
  height: 100px;
  padding: 40px 0 0 0;
  text-align: center;
  color: $primary;
}
.overlay-image {
  background-color: white;
}
.alert-required-transfer-queue {
  color: $primary;
  text-align: center;
  padding: 0 0 6px 0;
}
.action {
  text-align: center;
  position: relative;
  background-color: #fff;

  .line {
    border-bottom: 1px solid $border-color;
    position: absolute;
    width: 60%;
    left: 20%;
    top: 40%;
    margin-top: -1px;
    z-index: 1;
  }
  .value {
    font-size: $font-size-sub;
    background-color: #fff;
    position: relative;
    z-index: 2;
    padding: 10px;
    display: inline-block;
  }
}

.v-icon--disabled {
  pointer-events: auto !important;
}

// use in  system-message

.scroll-container {
  overflow-y: scroll;
  padding-bottom: 40px;
}

.system-message {
  text-align: center;
  font-size: 14px;
}
.wrap-word {
  display: inline-block;
  width: 250px !important;
  word-wrap: break-word;
}

.box-tuning {
  background: #fbfbfb;
  padding: 5px;
  border: 1px solid #e0e2ef;
  border-radius: 8px;
  margin-bottom: 20px;
}
//end use in  system-message

.text-small {
  font-size: 0.95rem;
}
</style>
